import {
  get,
} from '@/utils/request';

const url = 'administrator-roles';

export function index({ is_all, page, size }) {
  return get({
    url,
    data: {
      is_all: is_all ? 1 : 0,
      page,
      size,
    },
  });
}
